import React from 'react'
import Title from '../../../../components/typography/title.component'
import Button from '../../../../components/buttons/buttons.component'
import PeriodInputs from '../../../../components/form-components/period-inputs.component'
import ClientTicketModal from './components/client-ticket-modal-container.component'
import InnerPageContainer from '../../../../components/layout/private/inner-page-container.component'
import PurchasePagination from './components/purchase-pagination-container.component'
import { Formik } from 'formik'
import { connect } from 'react-redux'
import { StyledForm } from './styles/styled-form.style'
import { withRouter } from 'react-router-dom'
import { myPurchasesActions } from './my-purchases.actions'
import { SaleService } from '../../../../services/sale.service'
import { clientActions, toastActions } from '../../../../actions'
import { bindActionCreators } from 'redux'
import {
	SelectInput,
	AsyncSelectInput
} from '../../../../components/form-components/inputs.component'

class MyPurchasesPage extends React.Component {
	constructor(props) {
		super(props)

		this.isExporting = false
		// TODO: verificar a possibilidade de criar um ducks pra isso
		this.state = {
			period: 30,
			status: '',
			products: [],
			productId: '',
			dateEnd: null,
			dateStart: null,
			forceReloadData: 0
		}

		this.onSubmit = onSubmit.bind(this)
		this.loadOptions = loadOptions.bind(this)
		this.renderFormik = renderFormik.bind(this)
		this.handleCancelSomeTicket = handleCancelSomeTicket.bind(this)
	}

	componentWillMount() {
		this.props.getAvailablePointsToBuy()
	}

	componentDidMount() {
		setTimeout(() => {
			this.refs.form.submitForm()
		}, 0)

		SaleService.getProducts()
			.then(({ data }) => {
				this.setState({ products: data })
			})
			.catch(() => {
				this.props.toastWarning({
					message: 'Não foi possível carregar a lista de produtos.'
				})
			})
	}

	render() {
		const { availablePointsToBuy } = this.props
		const { dateStart, dateEnd, productId, status, forceReloadData } = this.state
		const annualLimit = Number(250000).toLocaleString('pt-BR')
		// TODO: user selectors
		const availablePoints = Number(availablePointsToBuy).toLocaleString(
			'pt-BR'
		)

		return (
			<InnerPageContainer>
				<Title>Minhas compras</Title>
				<h3 className="center">
					Você ainda pode comprar{' '}
					<span className="blue bold">{availablePoints}</span> pontos
					Muviflex
				</h3>
				<p className="center">
					Limite anual: {annualLimit} pontos para compra
				</p>
				<h3 className="semi-bold orange">Filtros</h3>
				<Formik
					ref="form"
					onSubmit={this.onSubmit}
					initialValues={this.state}
					render={this.renderFormik}
				/>
				<PurchasePagination
					params={{ dateStart, dateEnd, productId, status }}
					forceReloadData={forceReloadData}
				/>
				<ClientTicketModal handleCancelTicket={this.handleCancelSomeTicket} />
			</InnerPageContainer>
		)
	}
}

function onSubmit(values) {
	const { exportData } = this.props
	const params = Object.assign({}, values)
	if (this.isExporting) {
		this.isExporting = false
		exportData(params)
	} else {
		this.setState({
			status: values.status,
			dateEnd: values.finalDate,
			productId: values.productId,
			dateStart: values.initialDate
		})
	}
}

function handleCancelSomeTicket() {
	const data = Math.random()
	this.setState({ forceReloadData: data })
}

function renderFormik(props) {
	return (
		<StyledForm noValidade onSubmit={props.handleSubmit}>
			<PeriodInputs {...props} />
			<AsyncSelectInput
				{...props}
				id="productId"
				label="Produto"
				style={{ width: '100%' }}
				loadOptions={this.loadOptions}
				defaultOptions={this.state.products}
			/>
			<SelectInput
				{...props}
				id="status"
				label="Situação"
				options={statusOptions}
				defaultValue={statusOptions[0]}
			/>
			<div className="buttons">
				<Button
					secondary
					type="button"
					onClick={exportData.bind(this)}>
					Exportar compras de passagem
				</Button>
				<Button primary type="submit">
					Consultar
				</Button>
			</div>
		</StyledForm >
	)
}

function exportData() {
	this.isExporting = true
	this.refs.form.submitForm()
}

function loadOptions(inputValue, callback) {
	callback(
		[{ value: '', label: 'Todos' }, ...this.state.products]
			.filter(d =>
				d.label.toLowerCase().includes((inputValue || '').toLowerCase())
			)
			.slice(0, 11)
			.map(({ label, value }) => ({
				value,
				label
			}))
	)
}

const statusOptions = [
	{ value: '', label: 'Todas' },
	{ value: 'Pendente', label: 'Pendente' },
	{ value: 'Concluído', label: 'Concluído' },
	{ value: 'Cancelado', label: 'Cancelado' },
	{ value: 'Falhou', label: 'Falhou' },
	{ value: 'Reembolsado', label: 'Reembolsado' }
]

const mapStateToProps = ({ client }) => ({
	availablePointsToBuy: client.availablePointsToBuy
})

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			...myPurchasesActions,
			toastWarning: toastActions.warning,
			getAvailablePointsToBuy: clientActions.getAvailablePointsToBuy
		},
		dispatch
	)

const connectedMyPurchasePage = withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(MyPurchasesPage)
)

export { connectedMyPurchasePage as ModuleRootComponent }
